import useWizardFormCtx from '../../../ctx-provider/useWizardFormCtx';
import StvTitel, { getFormText } from '../../../../../../consumer/form/dto/StvTitel';
import SelectField from '../../../../../cmp/input/SelectField';
import SelectMenuItem from '../../../../../cmp/input/SelectMenuItem';
import FormBo from '../../FormBo';
import { useState } from 'react';
import GtmFormularfeldId from '../../../../../../gtm/types/GtmFormularfeldId';

export const exportVnTitel = (bo: FormBo) => bo.vnTitel;

export const importVnTitel = (vnTitel?: StvTitel) => vnTitel;

const VnTitel = () => {
    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [vnTitel, setVnTitel] = useState(wizardFormBo.antrag.vnTitel);

    // Formulardaten werden aktualisiert
    const handleOnChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value;
        const valueEnum = StvTitel[value as StvTitel];
        setVnTitel(valueEnum)

        wizardFormBo.antrag.vnTitel = valueEnum;
        fireWizardFormBo(wizardFormBo);
    }

    return (
        <SelectField id='vnTitel' idGtm={GtmFormularfeldId.vnTitel}
            value={vnTitel} onChange={handleOnChange} fullWidth>
            <SelectMenuItem value={StvTitel.KEIN_TITEL}>{getFormText(StvTitel.KEIN_TITEL)}</SelectMenuItem>
            <SelectMenuItem value={StvTitel.DR}>{getFormText(StvTitel.DR)}</SelectMenuItem>
            <SelectMenuItem value={StvTitel.DR_DR}>{getFormText(StvTitel.DR_DR)}</SelectMenuItem>
            <SelectMenuItem value={StvTitel.PROF}>{getFormText(StvTitel.PROF)}</SelectMenuItem>
            <SelectMenuItem value={StvTitel.PROF_DR}>{getFormText(StvTitel.PROF_DR)}</SelectMenuItem>
        </SelectField>
    );
}

export default VnTitel;